import { render } from "./menu_editor.vue?vue&type=template&id=6b5fa173&scoped=true"
import script from "./menu_editor.vue?vue&type=script&lang=js"
export * from "./menu_editor.vue?vue&type=script&lang=js"

import "./menu_editor.vue?vue&type=style&index=0&id=6b5fa173&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5fa173"]])

export default __exports__